<template>
  <v-container fluid style="max-width: 1280px;">
    <v-layout alig-start>
      <v-flex>
        <!-- Listado personas -->
        <v-data-table :loading="loading" :headers="headers" :items="personas" :items-per-page="15" dense
          class="elevation-3">
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title class="hidden-sm-and-down">CLIENTES Y PROVEEDORES</v-toolbar-title>
              <v-divider class="mx-2 hidden-sm-and-down" inset vertical></v-divider>
              <!-- Impresion personas -->
              <v-btn icon small color="print" @click="crearPDF()" class="mr-1">
                <v-icon>print</v-icon>
              </v-btn>
              <!-- Fin Impresion personas -->
              <v-spacer />
              <!-- busqueda -->
              <v-text-field class="mr-1 text-xs-center" v-model.trim="buscar" append-icon="search" dense
                label="Búsqueda" @keyup="listar()" single-line hide-details></v-text-field>
              <!-- Fin busqueda -->
              <v-spacer />
              <!-- Modal crear y modificar -->
              <v-dialog v-model="dialog" max-width="800px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" class="hidden-sm-and-down" v-on="on" small outlined>Nuevo</v-btn>
                  <v-btn color="primary" class="hidden-md-and-up" v-on="on" fab x-small outlined>
                    <v-icon>add</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar dark dense class="primary" flat>
                    <v-toolbar-title>{{ formTitle }} {{ tipo_persona }}</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-form v-model="isValid">
                      <v-row class="mt-2">
                        <v-col cols="6" sm="3">
                          <v-select dense v-model="tipo_persona" :items="tipo_personas" label="Tipo Persona"
                            :rules="[v => !!v || 'Tipo persona requerido']" hide-details></v-select>
                        </v-col>
                        <v-col cols="6" sm="3">
                          <v-select dense v-model="idtipo_documento" :items="tipo_documentos" label="Tipo Documento"
                            :rules="[v => !!v || 'Tipo documento requerido']" @change="num_documento = ''" hide-details>
                          </v-select>
                        </v-col>
                        <v-col cols="10" sm="5">
                          <v-text-field dense v-model.trim="num_documento" label="Numero Documento"
                            :rules="[v => !!v || 'Numero documento requerido', v => (idtipo_documento == 1 ? v.length == 8 || 'Numero DNI' : v.length == 11 || 'Numero RUC')]"
                            :maxlength="idtipo_documento == 1 ? 8 : 11"
                            :disabled="idtipo_documento == 1 ? false : idtipo_documento == 6 ? false : true"
                            @keypress="common.isNum($event)" hide-details></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="1">
                          <div class="text-center">
                            <v-btn x-small fab color="primary" class="white--text" :loading="desabilitarBuscar"
                              :disabled="(idtipo_documento == 1 && num_documento.length == 8 ? false : idtipo_documento == 6 && num_documento.length == 11 ? false : true) || desabilitarBuscar"
                              @click="extraerDocumento()">
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field dense v-model.trim="nombre"
                            :label="idtipo_documento == 1 ? 'Apellidos y Nombres' : 'Nombre'"
                            :rules="[v => !!v || 'Nombres requerido', v => (!!v && v.length >= 3 && v.length <= 200) || 'Nombres debe tener entre 3 a 200 caracteres']"
                            maxlength="100" prepend-inner-icon="person" v-uppercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-autocomplete dense @keyup="selectUbigeo()" :search-input.sync="buscar_ubigeo"
                            v-model="idubigeo" :items="ubigeos" label="Ubigeo" :rules="[v => !!v || 'Ubigeo requerido']"
                            prepend-inner-icon="pin_drop" clearable hide-details></v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field dense v-model.trim="direccion" label="Dirección"
                            :rules="[v => v.length <= 200 || 'La dirección no debe tener mas de 200 caracteres']"
                            maxlength="200" prepend-inner-icon="place" v-uppercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field dense v-model.trim="email" label="Email"
                            :rules="[v => v == '' ? !v : /.+@.+\..+/.test(v) || 'Ingrese un email valido', Rules.sinespacio]"
                            maxlength="60" prepend-inner-icon="mail" v-lowercase></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field dense v-model.trim="telefono" label="Teléfono"
                            :rules="[v => v.length <= 30 || 'El Teléfono no debe tener mas de 30 caracteres', Rules.unespacio]"
                            maxlength="30" prepend-inner-icon="phone" v-uppercase hide-details></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="py-0 pb-4 px-4 justify-center">
                    <v-btn color="error" @click="close" small outlined>
                      <v-icon left>close</v-icon>Cancelar
                    </v-btn>
                    <v-btn color="primary" @click="guardar" :loading="desabilitar" :disabled="desabilitar || !isValid"
                      small outlined>
                      <v-icon left>check</v-icon>Guardar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Fin Modal crear y modificar -->
            </v-toolbar>
          </template>

          <template v-slot:item.direccion="{ item }">
            <span>{{ item.direccion + " " + item.distrito }}</span>
          </template>
          <template v-slot:item.opciones="{ item }">
            <v-btn small icon>
              <v-icon color="primary" @click="editItem(item)">edit</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <!-- Fin Listado personas -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      personas: [],
      dialog: false,
      headers: [
        //{ text: "CdPer", value: "idpersona", sortable: false },
        //{ text: "TIPO", value: "tipo_persona", sortable: false },
        { text: "DOCUMENTO", value: "num_documento", sortable: false },
        { text: "NOMBRES", value: "nombre", sortable: false },
        //{ text: "DOC", value: "idtipo_documento" },
        //{ text: "DIRECCIÓN", value: "direccion", sortable: false },
        { text: "DIRECCIÓN", value: "direccion", sortable: false },
        //{ text: "EMAIL", value: "email", sortable: false },
        { text: "OPC.", value: "opciones", sortable: false, width: 50 },
      ],
      loading: false,

      buscar: "",
      buscar_ubigeo: "",

      editedIndex: -1,
      idpersona: "",
      tipo_persona: "",
      tipo_personas: ["Cliente", "Proveedor"],
      nombre: "",
      idtipo_documento: "",
      tipo_documentos: [],
      num_documento: "",
      idubigeo: "",
      ubigeos: [],
      direccion: "",
      telefono: "",
      email: "",

      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",

      desabilitar: false,
      desabilitarBuscar: false,

      isValid: true,

      /* Validaciones */
      Rules: {
        sinespacio: (v) =>
          (v || "").indexOf(" ") < 0 || "No se permite espacios",
        unespacio: (v) =>
          (v || "").indexOf("  ") < 0 || "No se permite mas de 1 espacio",
      },
    };
  },

  computed: {
    ...mapState(["logo"]),

    formTitle() {
      return this.editedIndex === -1 ? "Nuevo" : "Actualizar";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
    this.select();
  },

  methods: {
    ...mapActions(["snackBar"]),

    listar() {
      let me = this;
      me.loading = true;

      axios.get("api/Personas/ListarPersonasFiltro", {
        params: {
          buscar: me.buscar == "" ? "-" : me.buscar,
        },
      })
        .then(function (response) {
          //console.log(response);
          me.personas = response.data;
          me.loading = false;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    selectUbigeo(id) {
      let me = this;

      var ubigeosArray = [];

      if (id) {
        axios
          .get("api/Ubigeos/SelectUbigeos/" + id)
          .then(function (response) {
            ubigeosArray = response.data;
            ubigeosArray.map(function (x) {
              me.ubigeos.push({
                text: x.depprovdist,
                value: x.idubigeo,
              });
            });
          })
          .catch(function (error) {
            //console.log(url);
          });
      } else {
        axios.get("api/Ubigeos/SelectUbigeosFiltro", {
          params: {
            buscar:
              me.buscar_ubigeo == ""
                ? "-"
                : me.buscar_ubigeo == null
                  ? "-"
                  : me.buscar_ubigeo,
          },
        })
          .then(function (response) {
            ubigeosArray = response.data;
            ubigeosArray.map(function (x) {
              me.ubigeos.push({
                text: x.depprovdist,
                value: x.idubigeo,
              });
            });
          })
          .catch(function (error) {
            //console.log(url);
          });
      }
    },

    select() {
      let me = this;

      var tipo_documentosArray = [];
      axios.get("api/Tipo_Documentos/Select")
        .then(function (response) {
          tipo_documentosArray = response.data;
          tipo_documentosArray.map(function (x) {
            me.tipo_documentos.push({
              text: x.descripcion,
              value: x.idtipo_documento,
            });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    guardar() {
      let me = this;
      me.desabilitar = true;

      if (this.editedIndex > -1) {
        axios.put("api/Personas/Actualizar", {
          idpersona: me.idpersona,
          tipo_persona: me.tipo_persona,
          nombre: me.nombre,
          idtipo_documento: me.idtipo_documento,
          num_documento: me.num_documento,
          idubigeo: me.idubigeo,
          direccion: me.direccion,
          telefono: me.telefono,
          email: me.email,
        })
          .then(function (response) {
            me.desabilitar = false;
            me.snackBar({ cl: "success", msg: response.data });
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.snackBar({ cl: "error", msg: error.response.data });
            me.listar();
          });
      } else {
        axios.post("api/Personas/Crear", {
          tipo_persona: me.tipo_persona,
          nombre: me.nombre,
          idtipo_documento: me.idtipo_documento,
          num_documento: me.num_documento,
          idubigeo: me.idubigeo,
          direccion: me.direccion,
          telefono: me.telefono,
          email: me.email,
        })
          .then(function (response) {
            me.desabilitar = false;
            me.snackBar({ cl: "success", msg: response.data.mensaje });
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.snackBar({ cl: "error", msg: error.response.data });
            me.listar();
          });
      }
    },

    editItem(item) {
      this.idpersona = item.idpersona;
      this.tipo_persona = item.tipo_persona;
      this.nombre = item.nombre;
      this.idtipo_documento = item.idtipo_documento;
      this.num_documento = item.num_documento;
      this.idubigeo = item.idubigeo;
      this.selectUbigeo(item.idubigeo);
      this.direccion = item.direccion;
      this.telefono = item.telefono;
      this.email = item.email;
      this.editedIndex = 1;
      this.dialog = true;
    },

    extraerDocumento() {
      let me = this;
      me.desabilitarBuscar = true;

      if (me.idtipo_documento == 1) {
        axios.get("api/Personas/ConsultarDni", {
          params: {
            nrodoc: me.num_documento,
          },
        })
          .then(function (response) {
            //console.log(response.data)
            me.desabilitarBuscar = false;
            if (response.data.exito == true) {
              me.nombre = response.data.apellidoPaterno + " " + response.data.apellidoMaterno + " " + response.data.nombres;
              me.direccion = "";
              me.snackBar({ cl: "success", msg: response.data.mensaje });
            } else {
              me.nombre = "";
              me.direccion = "";
              me.snackBar({ cl: "error", msg: response.data.mensaje });
            }
          })
          .catch((err) => {
            me.desabilitarBuscar = false;
            me.nombre = "";
            me.direccion = "";
            me.snackBar({ cl: "error", msg: "Hubo un error" });
          });
      } else if (me.idtipo_documento == 6) {
        axios.post("api/Personas/Padron", {
          ruc: me.num_documento,
        })
          .then(function (response) {
            me.desabilitarBuscar = false;
            me.idubigeo = response.data.ubigeo;
            me.selectUbigeo(me.idubigeo);
            me.nombre = response.data.razon;
            me.direccion =
              response.data.direccion == null
                ? ""
                : response.data.direccion.trim();
            me.snackBar({ cl: "info", msg: "Contribuyente con estado " + response.data.estado + " y condición " + response.data.condicion });
          })
          .catch(function (error) {
            me.desabilitarBuscar = false;
            me.nombre = "";
            me.direccion = "";
            me.snackBar({ cl: "error", msg: error.response.data });
          });
      }
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.idpersona = "";
      this.tipo_persona = "";
      this.nombre = "";
      this.idtipo_documento = "";
      this.num_documento = "";
      this.idubigeo = "";
      this.ubigeos = [];
      this.direccion = "";
      this.telefono = "";
      this.email = "";

      this.editedIndex = -1;
    },

    crearPDF() {
      var columns = [
        { header: "COD.", dataKey: "idpersona" },
        { header: "PERSONA", dataKey: "tipo_persona" },
        { header: "DOCUMENTO", dataKey: "num_documento" },
        { header: "NOMBRE", dataKey: "nombre" },
        //{ header: "TIPO", dataKey: "idtipo_documento" },
        { header: "DIRECCIÓN", dataKey: "direccion" },
        { header: "TELEFONO", dataKey: "telefono" },
        { header: "EMAIL", dataKey: "email" },
      ];
      var body = [];

      this.personas.map(function (x) {
        body.push({
          idpersona: x.idpersona,
          tipo_persona: x.tipo_persona,
          nombre: x.nombre,
          // idtipo_documento: x.idtipo_documento,
          num_documento: x.num_documento,
          direccion: x.direccion + " " + x.distrito,
          telefono: x.telefono,
          email: x.email,
        });
      });

      // Titulo y logo
      const addHeaders = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text("LISTADO DE CLIENTES Y PROVEEDORES", doc.internal.pageSize.width / 2, 45, {
            align: "center",
          });
          doc.addImage(imgData, "JPEG", 40, 17, 70, 49.39);
        }
      };
      // Pie de pagina
      const addFooters = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "italic");
        doc.setFontSize(7);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text(
            "Pagina " + String(i) + " de " + String(pageCount),
            doc.internal.pageSize.width / 2,
            820,
            {
              align: "center",
            }
          );
        }
      };

      // Configurando hoja
      var imgData = "data:image/png;base64," + this.logo;
      var doc = new jsPDF("l", "pt");

      doc.autoTable({
        columns,
        body,
        margin: { top: 70 },
        headStyles: {
          fillColor: [46, 78, 121],
          fontSize: 7,
          halign: "center",
        },
        bodyStyles: { textColor: 0, fontSize: 8 },
        columnStyles: {
          idpersona: { cellWidth: 30 },
          tipo_persona: { cellWidth: 50 },
          num_documento: { cellWidth: 65 },
          nombre: { cellWidth: 180 },
          //idtipo_documento: { cellWidth: 30 },
          direccion: { cellWidth: "auto" },
          telefono: { cellWidth: 80 },
          email: { cellWidth: 100 },
        },
      });

      addHeaders(doc);
      addFooters(doc);
      doc.save("ClientesProveedores.pdf");
    },
  },
};
</script>